<template>
    
    <span>
        <Badge type="info" v-if="commande.commandeStatut && commande.commandeStatut.infos" >{{ commande.commandeStatut.infos }}</Badge>
        <Badge type="info" v-if="commande.commandeStatut && commande.commandeStatut.facturationStatutLibelle" >{{ commande.commandeStatut.facturationStatutLibelle }}</Badge>
        <Badge type="success" v-if="commande.commandeStatut && commande.commandeStatut.budgetStatut == 2" >{{ commande.commandeStatut.budgetStatutLibelle }} <i class="fa fa-cog"></i></Badge>
        <Badge type="success" v-if="commande.commandeStatut && commande.commandeStatut.budgetStatut == 3" >{{ commande.commandeStatut.budgetStatutLibelle }} <i class="fa fa-user"></i></Badge>
        <Badge type="warning" v-if="commande.commandeStatut && commande.commandeStatut.budgetStatut == 4" >{{ commande.commandeStatut.budgetStatutLibelle }}</Badge>
        <Badge type="danger" v-if="commande.commandeStatut && commande.commandeStatut.budgetStatut == 5" >{{ commande.commandeStatut.budgetStatutLibelle }}</Badge>
        <Badge type="warning" v-if="!commande.isPaid" >Non payé</Badge>
        <Badge type="secondary" v-if="commande.commandeStatut && commande.commandeStatut.isDone" >Close</Badge>
        <Badge type="success" v-if="commande.commandeStatut && !commande.commandeStatut.isDone" >En cours</Badge>        
    </span>

</template>

<script>

import Badge from '@/components/badge/Badge.vue'

export default {

    components: {
        Badge
    },

    props: {
        commande: Object
    }
}
</script>


